import { Link } from "@tanstack/react-router";
import { SectionTabs } from "../../components/ui";

/**
 * Notifications is a product area of its own — rules, channels, delivery log —
 * reached from the Respond group in the sidebar. Its pages navigate between
 * themselves here rather than borrowing the organization settings rail, which
 * lists none of them and only made the page look like it took a wrong turn.
 */
export function NotificationsTabs({ orgId }: { orgId: string }) {
  return (
    <SectionTabs label="Notifications">
      <Link to={"/orgs/$org/notifications" as never} params={{ org: orgId } as never} activeOptions={{ exact: true }}>
        Rules
      </Link>
      <Link to={"/orgs/$org/notifications/channels" as never} params={{ org: orgId } as never}>
        Channels
      </Link>
      <Link to={"/orgs/$org/notifications/deliveries" as never} params={{ org: orgId } as never}>
        Delivery log
      </Link>
    </SectionTabs>
  );
}
